import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ToDoLists from './components/ToDoLists';

const toDoLists = (props,{ t }) => (
  <Container>
    <ToDoLists {...props} />
  </Container>
);

toDoLists.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(toDoLists);
